import Tag from '@atoms/Tag/Tag';
import ProductStockStatusEnum from '@models/enums/ProductStockStatusEnum';
import TagTypesEnum from '@models/enums/TagTypesEnum';
import { ITags } from '@models/ITags';

const Tags = ({
  hidePriceFromSavePill,
  pricingData,
  newProductLabel,
  savePriceLabel,
  statusLabels,
  dataTestId,
}: ITags) => (
  <>
    {newProductLabel && (
      <Tag
        tagType={TagTypesEnum.Secondary}
        text={newProductLabel}
        pointerStates={false}
        dataTestId={dataTestId}
      />
    )}

    {pricingData?.status === ProductStockStatusEnum.OutOfStock &&
      statusLabels?.outOfStockLabel && (
        <Tag
          tagType={TagTypesEnum.Secondary}
          pointerStates={false}
          text={statusLabels.outOfStockLabel}
          dataTestId={dataTestId}
        />
      )}

    {pricingData?.status === ProductStockStatusEnum.SoldOut &&
      statusLabels?.soldOutLabel && (
        <Tag
          tagType={TagTypesEnum.Secondary}
          pointerStates={false}
          text={statusLabels.soldOutLabel}
          dataTestId={dataTestId}
        />
      )}

    {pricingData?.status === ProductStockStatusEnum.PreOrder &&
      statusLabels?.preOrderLabel && (
        <Tag
          tagType={TagTypesEnum.Secondary}
          pointerStates={false}
          text={statusLabels.preOrderLabel}
          dataTestId={dataTestId}
        />
      )}

    {pricingData?.isCommerceEnabled &&
      pricingData.status === ProductStockStatusEnum.BackOrder &&
      statusLabels?.backOrderLabel && (
        <Tag
          tagType={TagTypesEnum.Secondary}
          pointerStates={false}
          text={statusLabels.backOrderLabel}
          dataTestId={dataTestId}
        />
      )}

    {!!(
      pricingData?.formattedAmountSaved &&
      pricingData.amountSaved > 0 &&
      savePriceLabel
    ) && (
      <Tag
        tagType={TagTypesEnum.Four}
        pointerStates={false}
        text={`${savePriceLabel} ${
          hidePriceFromSavePill ? '' : pricingData.formattedAmountSaved
        }`}
        dataTestId={dataTestId}
      />
    )}
  </>
);

export default Tags;
